<template>
  <v-form v-model="form.valid">
    <v-card max-width="700" class="mx-auto">
      <v-toolbar color="teal" dark>
        <v-icon class="toolbar-title-icon">mdi-card-plus</v-icon>
        <v-toolbar-title>Nieuwe Darkweb licentie</v-toolbar-title>
      </v-toolbar>
      <v-sheet>
        <v-container>
          <v-text-field v-model="form.amount" :rules="form.rules.amount" />
          <v-menu min-width="auto">
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="form.input.expirationDate"
                prepend-icon="mdi-calendar"
                readonly
                label="Verloopdatum"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="form.input.expirationDate"
              :min="new Date().toISOString().slice(0, 10)"
            />
          </v-menu>
          <v-btn
            color="primary"
            @click="createNewLicense"
            :loading="form.loading"
          >Aanmaken
          </v-btn
          >
        </v-container>
      </v-sheet>
    </v-card>
  </v-form>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory";

export default {
  name: "NewDarkwebLicenseForm",
  data() {
    return {
      form: {
        valid: false,
        input: {
          expirationDate: undefined
        },
        amount: 1,
        loading: false,
        rules: {
          amount: [
            v => !!v || "Veld is verplicht",
            v => !isNaN(v) || "Voer een getal in",
            v => Number.isInteger(Number(v)) || "Voer een geheel getal in",
            v => v > 0 || "Voer een getal groter dan 0 in"
          ]
        }
      }
    };
  },
  methods: {
    createNewLicense() {
      this.form.loading = true;
      let orgId = this.$route.params["organisation"];

      RepositoryFactory.get("darkwebLicenses")
        .store({
          expiration_date: this.form.input.expirationDate,
          organisation_id: orgId,
          amount: this.form.amount
        })
        .then(() => {
          this.$emit("licenseCreated");
        })
        .catch(() => {
          this.$store.dispatch(
            "notifications/setErrorMessage",
            "feedback.licenses.error"
          );
        })
        .finally(() => (this.form.loading = false));
    }
  },
  computed: {
    oneYear() {
      let nextYear = new Date();
      nextYear.setFullYear(nextYear.getFullYear() + 1);
      return nextYear.toISOString();
    }
  }
};
</script>

<style scoped>

</style>
